import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const UdsSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-uds-simulator" />;

export default UdsSimulatorGuidePage;
